import BaseListStyle from "../../styles/BaseListStyle"; 

const PermitManagementStyles = (theme) => {
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    button: {
      margin: theme.spacing(1),
      padding: 6,
      marginTop: 12,
    }
  }
}

export default PermitManagementStyles;
